<div fxLayout="column" fxFlex fusePerfectScrollbar>
  <mat-list class="date" cdkFocusRegionStart>
    <h3 matSubheader cdkFocusInit>
      <span>Aujourd'hui</span>
    </h3>

    <div class="secondary-text mat-display-1 mb-0 p-4">
      <div class="mb-12">
        {{ date | abpDate : 'EEEE' }}
      </div>
      <div fxLayout="row" fxLayoutAlign="start start">
        <span> {{ date | abpDate : 'd' }}</span>
        <span class="mat-subheading-1"> </span>
        <span> {{ date | abpDate : 'MMMM' }}</span>
      </div>
    </div>
  </mat-list>
</div>
